import { render, staticRenderFns } from "./MintalMesPrdMonthPlanList.vue?vue&type=template&id=2f5397a6&"
import script from "./MintalMesPrdMonthPlanList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdMonthPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports